import {Component, EventEmitter, Inject, OnInit, Output} from '@angular/core';
import {FormBuilder, FormControl, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Master} from '../../../../admin/models/master.interface';
import {QuestionsService} from '../../../services/questions.service';

@Component({
  selector: 'app-edit-question-categories',
  templateUrl: './edit-question-categories.component.html',
  styleUrls: ['./edit-question-categories.component.scss']
})
export class EditQuestionCategoriesComponent implements OnInit {

  questionCategoryEditForm = this.formBuilder.group({
    description: ['', Validators.required],
  });

  get descriptionControl(): FormControl {
    return this.questionCategoryEditForm.get('description') as FormControl;
  }

  @Output()
  editEvent: EventEmitter<void> = new EventEmitter<void>();

  constructor(@Inject(MAT_DIALOG_DATA) public data: Master,
              private dialogRef: MatDialogRef<EditQuestionCategoriesComponent>,
              private readonly formBuilder: FormBuilder,
              private readonly questionsService: QuestionsService) { }

  ngOnInit(): void {
    this.descriptionControl.setValue(this.data.description);
  }

  sendEditionRequest(): void {
    this.questionsService.editQuestionCategory(this.data.id, this.descriptionControl.value).subscribe(
      () => {
        this.editEvent.emit();
        this.closeDialog();
      },
      () => {
        this.closeDialog();
      }
    );
  }

  closeDialog(): void {
    this.dialogRef.close();
  }


}
